<script>
export default {
    name: "PrintPrescription",

    data() {

        return {
            patient: {},
            prescriptions: [],
        };
    },

    mounted() {

        Promise.allSettled([ this.fetchPatient(), this.fetchPrescriptions(), ]).then(() => {
            window.print();
            window.onafterprint = () => window.close();
            window.oncancel = () => window.close();
        }).catch(() => {});
    },

    methods: {

        fetchPatient() {

            return this.$http.get(`PatientRegistration/GetSpecificPatient?PatientID=${this.$route.params.patientID}`).then(response => {
                this.patient = response.data.length ? response.data[0] : {};
            }).catch(() => {});
        },

        fetchPrescriptions() {
            let url = `MedicalFile/GetPatientDrugsandConsumblesTreatmentforDate`;
                url += `?PatientID=${this.$route.params.patientID}`;
                url += `&VisitNo=${this.$route.params.visitNO}`;
                url += `&Date=${this.$moment().format(`YYYY-MM-DD`)}`;

            return this.$http.get(url).then(({ data }) => {
                this.prescriptions = data;
            }).catch(() => {});
        },
    },
}
</script>
<template>
    <div class="w-full flex flex-wrap">
        <tail-address-header></tail-address-header>
        <div class="w-full flex flex-wrap p-1 my-1 border-b-2 border-t-2 border-gray-800">
            <div class="w-full p-1">
                <h5 class="text-sm"><span class="font-bold">Name:</span> {{ patient.names }}</h5>
            </div>
            <div class="w-full p-1">
                <h5 class="text-sm"><span class="font-bold">Visit No:</span> {{ patient.visitNo || `-` }}</h5>
            </div>
            <div class="w-full p-1">
                <h5 class="text-sm"><span class="font-bold">MRN:</span> {{ patient.patienT_ID }}</h5>
            </div>
            <div class="w-full p-1">
                <h5 class="text-sm font-bold">Printed By: {{ $root.username }}</h5>
            </div>
        </div>
        <table class="table">
            <thead class="text-xs font-bold">
                <tr>
                    <th class="p-tiny">Date</th>
                    <th class="p-tiny">Drug</th>
                    <th class="p-tiny">Description</th>
                    <th class="p-tiny">Requested By</th>
                </tr>
            </thead>
            <tbody>
                <tr class="text-xs font-bold" v-for="(pres, idx) in prescriptions" :key="idx">
                    <td class="p-tiny">{{ pres.date | dateFormat }}</td>
                    <td class="p-tiny">{{ pres.drug }}</td>
                    <td class="p-tiny">{{ pres.description }}</td>
                    <td class="p-tiny">{{ pres.requested_By }}</td>
                </tr>
            </tbody>
        </table>
        
    </div>
</template>